import { defineMessages } from 'react-intl'

export default defineMessages({
    notAvailable: {
        defaultMessage: 'No tenemos estaciones disponibles en esta zona, mueve el mapa y vuelve a buscar.',
    },
    notFound: {
        defaultMessage: 'Lo sentimos, no hemos encontrado resultados',
    },
})
